import axios from 'axios';
import store from '../redux/redux-store';
import { setUser, logout } from '../redux/authSlice';

const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

const originalFetch = window.fetch;

// Единственный источник ролей и привилегий — /api/users/profile.
// Из токена/куки ничего не декодируем: access-токен хранит только sub.
const fetchProfile = async () => {
  const response = await originalFetch('/api/users/profile', {
    method: 'GET',
    credentials: 'include',
  });
  if (!response.ok) return false;
  const user = await response.json();
  const roles = (user.roles || []).map((role) => role.name);
  const permissions = (user.roles || [])
      .flatMap((role) => (role.privileges || []).map((privilege) => privilege.name));
  store.dispatch(setUser({ email: user.email, user: user.email, roles, permissions }));
  return true;
};

// Общий "синглтон" для ротации refresh-токена: параллельные 401-ы
// дедуплицируются в один вызов /api/auth/refresh.
let refreshPromise = null;

const refreshAuth = () => {
  if (!refreshPromise) {
    refreshPromise = fetch('/api/auth/refresh', {
      method: 'POST',
      credentials: 'include',
    })
        .then((res) => {
          if (!res.ok) {
            throw new Error('Refresh failed');
          }
          return res.json();
        })
        .then(async () => {
          // После ротации токена всегда перечитываем роли и привилегии с сервера
          await fetchProfile();
        })
        .catch((err) => {
          forceLogout();
          throw err;
        })
        .finally(() => {
          refreshPromise = null;
        });
  }
  return refreshPromise;
};

const forceLogout = async () => {
  try {
    await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' });
  } catch (e) {
    // cookie всё равно очистим локально ниже
  }
  store.dispatch(logout());
  if (!window.location.pathname.startsWith('/login')) {
    window.location.href = '/login';
  }
};

const isAuthEndpoint = (url) =>
    url.includes('/auth/refresh') ||
    url.includes('/auth/logout') ||
    url.includes('/perform_login');

// Перехватчик для запросов через библиотеку axios (админские разделы)
axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const { config, response } = error || {};
      if (response && response.status === 401
          && config
          && !config._retry
          && !isAuthEndpoint(String(config.url || ''))) {
        config._retry = true;
        return refreshAuth().then(() => axios(config));
      }
      return Promise.reject(error);
    }
);

// Патч window.fetch: любой fetch()-запрос, вернувший 401, автоматически
// ротирует refresh-токен и повторяется один раз.
window.fetch = async (input, init) => {
  const attempt = () => {
    if (input instanceof Request) {
      return originalFetch(input.clone(), init);
    }
    return originalFetch(input, init);
  };

  const response = await attempt();
  if (response.status === 401) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!isAuthEndpoint(url)) {
      try {
        await refreshAuth();
        return await attempt();
      } catch (e) {
        return response;
      }
    }
  }
  return response;
};

export { api };
